import * as React from 'react'

import { ScaleLine, ScalePoint, ScaleWrapper } from './styles'

const MAX_FIT = 5
const MIN_FIT = 1

const clampFit = (originalNum: number): number => Math.max(Math.min(MAX_FIT, originalNum), MIN_FIT)

export const FitScale: React.FC<{ fit: number }> = ({ fit }) => {
  return (
    <ScaleWrapper highlightChild={clampFit(fit)}>
      {Array(MAX_FIT)
        .fill(null)
        .map((_, index) => (
          <ScalePoint data-testid='fit-scale-point' key={index} />
        ))}
      <ScaleLine />
    </ScaleWrapper>
  )
}
